import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalExceptionHandlerPopupComponent } from './globalexceptionhandler-popup.component';
import { DraggableModule } from '../../directives/draggable/draggable.module';
import { FormsModule } from '@angular/forms';
import { ResizableModule } from '../../directives/resizable/resizable-module';
import { GridsModule } from '../../components/grids/grids.module';

@NgModule({
  declarations: [
    GlobalExceptionHandlerPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DraggableModule,
    ResizableModule,
    GridsModule
  ],
  exports: [
    GlobalExceptionHandlerPopupComponent
  ]
})
export class GlobalExceptionHandlerModule { }
